import React from "react";
import SvgIcon from '@/pages/home/components/SvgIcon';

interface DataFomatType {
  value: string | number;
  type: 'up' | 'down' | '';
  growth: string | number;
  preClassName: string;
  hasPermission?: boolean;
}

export default function ValueGrowth(props: DataFomatType) {
  const { value, type, growth, preClassName, hasPermission = true } = props;
  const newValueText = !hasPermission ? '*' : value;
  const newGrowthText = !hasPermission ? '*' : growth;
  return (
    <>
      <div className={`${preClassName}-data`}>{newValueText}</div>
      {
        (type === 'up' || type === 'down') && hasPermission ?
          <div className={type === 'up' ? `${preClassName}-green` : `${preClassName}-red`}>
            {growth}
            <SvgIcon className={`${preClassName}-icon`} type={type === 'up' ? 'green-up-new' : 'red-down-new'} />
          </div>
          : <div className={`${preClassName}-nodata`}>{newGrowthText}</div>
      }
    </>
  )
}